import { render, staticRenderFns } from "./storageCoordination.vue?vue&type=template&id=f6627372"
import script from "./storageCoordination.vue?vue&type=script&lang=js"
export * from "./storageCoordination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports